import { render, staticRenderFns } from "./sandTable.vue?vue&type=template&id=1d07a0e4&scoped=true"
import script from "./sandTable.vue?vue&type=script&lang=js"
export * from "./sandTable.vue?vue&type=script&lang=js"
import style0 from "./sandTable.vue?vue&type=style&index=0&id=1d07a0e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d07a0e4",
  null
  
)

export default component.exports